import React, { useState } from 'react';
import { TrendingUp, Award, Target, Euro, Clock, BarChart3, Users, ChevronDown } from 'lucide-react';
import { BarChart, Bar, LineChart, Line, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
const teamMembers = [{
  id: 1,
  name: 'Marco Rossi',
  role: 'Senior Sales Manager',
  performance: 95,
  deals: 23,
  revenue: 580000,
  conversionRate: 42,
  avgDealTime: 24,
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop'
}, {
  id: 2,
  name: 'Laura Bianchi',
  role: 'Sales Manager',
  performance: 92,
  deals: 19,
  revenue: 520000,
  conversionRate: 38,
  avgDealTime: 26,
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop'
}, {
  id: 3,
  name: 'Giuseppe Verdi',
  role: 'Sales Manager',
  performance: 88,
  deals: 17,
  revenue: 480000,
  conversionRate: 35,
  avgDealTime: 28,
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop'
}, {
  id: 4,
  name: 'Sofia Romano',
  role: 'Junior Sales Manager',
  performance: 85,
  deals: 15,
  revenue: 420000,
  conversionRate: 32,
  avgDealTime: 30,
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop'
}, {
  id: 5,
  name: 'Andrea Ferrari',
  role: 'Junior Sales Manager',
  performance: 82,
  deals: 12,
  revenue: 380000,
  conversionRate: 28,
  avgDealTime: 32,
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop'
}];
const monthlyComparison = [{
  month: 'Gen',
  marco: 85,
  laura: 82,
  giuseppe: 78,
  sofia: 75,
  andrea: 72
}, {
  month: 'Feb',
  marco: 88,
  laura: 85,
  giuseppe: 80,
  sofia: 78,
  andrea: 75
}, {
  month: 'Mar',
  marco: 90,
  laura: 87,
  giuseppe: 83,
  sofia: 80,
  andrea: 77
}, {
  month: 'Apr',
  marco: 92,
  laura: 89,
  giuseppe: 85,
  sofia: 82,
  andrea: 79
}, {
  month: 'Mag',
  marco: 93,
  laura: 90,
  giuseppe: 86,
  sofia: 84,
  andrea: 80
}, {
  month: 'Giu',
  marco: 95,
  laura: 92,
  giuseppe: 88,
  sofia: 85,
  andrea: 82
}];
const sectorPerformance = [{
  sector: 'Fashion',
  deals: 45,
  revenue: 1200000,
  conversion: 38
}, {
  sector: 'Lifestyle',
  deals: 32,
  revenue: 850000,
  conversion: 35
}, {
  sector: 'Design',
  deals: 28,
  revenue: 720000,
  conversion: 32
}, {
  sector: 'Gioielli',
  deals: 25,
  revenue: 980000,
  conversion: 42
}, {
  sector: 'Food',
  deals: 18,
  revenue: 520000,
  conversion: 28
}];
const skillsComparison = [{
  skill: 'Negoziazione',
  marco: 95,
  laura: 90,
  giuseppe: 85,
  media: 88
}, {
  skill: 'Prospezione',
  marco: 92,
  laura: 88,
  giuseppe: 82,
  media: 85
}, {
  skill: 'Chiusura',
  marco: 94,
  laura: 91,
  giuseppe: 87,
  media: 89
}, {
  skill: 'Follow-up',
  marco: 90,
  laura: 93,
  giuseppe: 88,
  media: 90
}, {
  skill: 'Networking',
  marco: 88,
  laura: 92,
  giuseppe: 90,
  media: 89
}];
export function TeamPerformance() {
  const [selectedPeriod, setSelectedPeriod] = useState('6m');
  const [selectedMember, setSelectedMember] = useState<number | null>(null);
  const periods = [{
    value: '1m',
    label: 'Ultimo Mese'
  }, {
    value: '3m',
    label: 'Ultimi 3 Mesi'
  }, {
    value: '6m',
    label: 'Ultimi 6 Mesi'
  }, {
    value: '1y',
    label: 'Ultimo Anno'
  }];
  return <div className="space-y-6" data-id="element-3079">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-3080">
        <div data-id="element-3081">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-3082">
            Performance Team
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-3083">
            Analisi dettagliata delle performance individuali e di gruppo
          </p>
        </div>
        <div className="relative" data-id="element-3084">
          <select value={selectedPeriod} onChange={e => setSelectedPeriod(e.target.value)} className="appearance-none px-4 py-2 pr-10 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#1388ad] bg-white" data-id="element-3085">
            {periods.map(period => <option key={period.value} value={period.value} data-id="element-3086">
                {period.label}
              </option>)}
          </select>
          <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-3087" />
        </div>
      </div>
      {/* Team Ranking */}
      <div className="bg-white border border-gray-200 p-6 rounded-lg" data-id="element-3088">
        <div className="flex items-center justify-between mb-6" data-id="element-3089">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-3090">
            Classifica Performance
          </h3>
          <Award className="w-5 h-5 text-yellow-500" data-id="element-3091" />
        </div>
        <div className="space-y-4" data-id="element-3092">
          {teamMembers.map((member, index) => <div key={member.id} className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer" onClick={() => setSelectedMember(selectedMember === member.id ? null : member.id)} data-id="element-3093">
              <div className="flex items-center gap-4 flex-1" data-id="element-3094">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${index === 0 ? 'bg-yellow-100' : index === 1 ? 'bg-gray-200' : index === 2 ? 'bg-orange-100' : 'bg-gray-100'}`} data-id="element-3095">
                  <span className={`text-lg font-bold ${index === 0 ? 'text-yellow-600' : index === 1 ? 'text-gray-600' : index === 2 ? 'text-orange-600' : 'text-gray-500'}`} data-id="element-3096">
                    #{index + 1}
                  </span>
                </div>
                <img src={member.avatar} alt={member.name} className="w-12 h-12 rounded-full object-cover" data-id="element-3097" />
                <div className="flex-1 min-w-0" data-id="element-3098">
                  <p className="text-sm font-semibold text-gray-900 truncate" data-id="element-3099">
                    {member.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-3100">{member.role}</p>
                </div>
              </div>
              <div className="text-right" data-id="element-3101">
                <div className="flex items-center gap-2 justify-end mb-1" data-id="element-3102">
                  <div className="w-24 bg-gray-200 rounded-full h-2" data-id="element-3103">
                    <div className="bg-[#1388ad] h-2 rounded-full" style={{
                  width: `${member.performance}%`
                }} data-id="element-3104" />
                  </div>
                  <span className="text-sm font-semibold text-[#1388ad] min-w-[45px]" data-id="element-3105">
                    {member.performance}%
                  </span>
                </div>
                <div className="flex items-center gap-3 text-xs text-gray-500" data-id="element-3106">
                  <span data-id="element-3107">{member.deals} deals</span>
                  <span data-id="element-3108">€{(member.revenue / 1000).toFixed(0)}K</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      {/* Performance Trends */}
      <div className="bg-white border border-gray-200 p-6 rounded-lg" data-id="element-3109">
        <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3110">
          Andamento Performance Mensile
        </h3>
        <ResponsiveContainer width="100%" height={350} data-id="element-3111">
          <LineChart data={monthlyComparison} data-id="element-3112">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-3113" />
            <XAxis dataKey="month" stroke="#9ca3af" data-id="element-3114" />
            <YAxis stroke="#9ca3af" data-id="element-3115" />
            <Tooltip data-id="element-3116" />
            <Legend data-id="element-3117" />
            <Line type="monotone" dataKey="marco" stroke="#1388ad" strokeWidth={2} name="Marco Rossi" data-id="element-3118" />
            <Line type="monotone" dataKey="laura" stroke="#10b981" strokeWidth={2} name="Laura Bianchi" data-id="element-3119" />
            <Line type="monotone" dataKey="giuseppe" stroke="#f59e0b" strokeWidth={2} name="Giuseppe Verdi" data-id="element-3120" />
            <Line type="monotone" dataKey="sofia" stroke="#8b5cf6" strokeWidth={2} name="Sofia Romano" data-id="element-3121" />
            <Line type="monotone" dataKey="andrea" stroke="#ec4899" strokeWidth={2} name="Andrea Ferrari" data-id="element-3122" />
          </LineChart>
        </ResponsiveContainer>
      </div>
      {/* Metrics Comparison */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-3123">
        <div className="bg-white border border-gray-200 p-6 rounded-lg" data-id="element-3124">
          <div className="flex items-center gap-2 mb-4" data-id="element-3125">
            <Target className="w-5 h-5 text-[#1388ad]" data-id="element-3126" />
            <h3 className="text-lg font-semibold text-gray-900" data-id="element-3127">
              Tasso di Conversione
            </h3>
          </div>
          <div className="space-y-3" data-id="element-3128">
            {teamMembers.map(member => <div key={member.id} className="space-y-1" data-id="element-3129">
                <div className="flex items-center justify-between text-sm" data-id="element-3130">
                  <span className="text-gray-700" data-id="element-3131">{member.name}</span>
                  <span className="font-semibold text-[#1388ad]" data-id="element-3132">
                    {member.conversionRate}%
                  </span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-3133">
                  <div className="bg-[#1388ad] h-2 rounded-full" style={{
                width: `${member.conversionRate}%`
              }} data-id="element-3134" />
                </div>
              </div>)}
          </div>
        </div>
        <div className="bg-white border border-gray-200 p-6 rounded-lg" data-id="element-3135">
          <div className="flex items-center gap-2 mb-4" data-id="element-3136">
            <Clock className="w-5 h-5 text-[#1388ad]" data-id="element-3137" />
            <h3 className="text-lg font-semibold text-gray-900" data-id="element-3138">
              Tempo Medio Chiusura
            </h3>
          </div>
          <div className="space-y-3" data-id="element-3139">
            {teamMembers.map(member => <div key={member.id} className="flex items-center justify-between" data-id="element-3140">
                <span className="text-sm text-gray-700" data-id="element-3141">{member.name}</span>
                <span className="text-sm font-semibold text-gray-900" data-id="element-3142">
                  {member.avgDealTime} giorni
                </span>
              </div>)}
          </div>
        </div>
        <div className="bg-white border border-gray-200 p-6 rounded-lg" data-id="element-3143">
          <div className="flex items-center gap-2 mb-4" data-id="element-3144">
            <Euro className="w-5 h-5 text-[#1388ad]" data-id="element-3145" />
            <h3 className="text-lg font-semibold text-gray-900" data-id="element-3146">
              Revenue per Membro
            </h3>
          </div>
          <div className="space-y-3" data-id="element-3147">
            {teamMembers.map(member => <div key={member.id} className="flex items-center justify-between" data-id="element-3148">
                <span className="text-sm text-gray-700" data-id="element-3149">{member.name}</span>
                <span className="text-sm font-semibold text-[#1388ad]" data-id="element-3150">
                  €{(member.revenue / 1000).toFixed(0)}K
                </span>
              </div>)}
          </div>
        </div>
      </div>
      {/* Sector Performance */}
      <div className="bg-white border border-gray-200 p-6 rounded-lg" data-id="element-3151">
        <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3152">
          Performance per Settore
        </h3>
        <ResponsiveContainer width="100%" height={300} data-id="element-3153">
          <BarChart data={sectorPerformance} data-id="element-3154">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-3155" />
            <XAxis dataKey="sector" stroke="#9ca3af" data-id="element-3156" />
            <YAxis stroke="#9ca3af" data-id="element-3157" />
            <Tooltip data-id="element-3158" />
            <Legend data-id="element-3159" />
            <Bar dataKey="deals" fill="#1388ad" name="Trattative" data-id="element-3160" />
            <Bar dataKey="conversion" fill="#10b981" name="Conversione %" data-id="element-3161" />
          </BarChart>
        </ResponsiveContainer>
      </div>
      {/* Skills Comparison */}
      <div className="bg-white border border-gray-200 p-6 rounded-lg" data-id="element-3162">
        <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3163">
          Confronto Competenze (Top 3)
        </h3>
        <ResponsiveContainer width="100%" height={400} data-id="element-3164">
          <RadarChart data={skillsComparison} data-id="element-3165">
            <PolarGrid stroke="#e5e7eb" data-id="element-3166" />
            <PolarAngleAxis dataKey="skill" stroke="#9ca3af" data-id="element-3167" />
            <PolarRadiusAxis stroke="#9ca3af" data-id="element-3168" />
            <Radar name="Marco Rossi" dataKey="marco" stroke="#1388ad" fill="#1388ad" fillOpacity={0.3} data-id="element-3169" />
            <Radar name="Laura Bianchi" dataKey="laura" stroke="#10b981" fill="#10b981" fillOpacity={0.3} data-id="element-3170" />
            <Radar name="Giuseppe Verdi" dataKey="giuseppe" stroke="#f59e0b" fill="#f59e0b" fillOpacity={0.3} data-id="element-3171" />
            <Radar name="Media Team" dataKey="media" stroke="#6b7280" fill="#6b7280" fillOpacity={0.1} strokeDasharray="5 5" data-id="element-3172" />
            <Legend data-id="element-3173" />
            <Tooltip data-id="element-3174" />
          </RadarChart>
        </ResponsiveContainer>
      </div>
    </div>;
}